import ProgressBar from "Components/shared/progressbar";
import React from "react";
import styles from "./progress.module.css";

const StageHeader = ({ currentStage, totalStages, children, className, left, right,...props }) => {
  return (
    <div className={`${styles.root} ${className || ""}`} {...props}>
      {left && <div className={styles.Left}>{left}</div>}
      <div style={{flexGrow:"1"}} className={`${styles.StageHeader} center`}>
        <div className={`w-full ${styles.ProgressBar}`}>
          <ProgressBar value={((currentStage - 1) * 100) / (totalStages - 1)} />
        </div>
        <HeaderItems>
          {children}
        </HeaderItems>
      </div>
      {right && <div className={styles.Right}>{right}</div>}
    </div>
    
  );
};

const HeaderItems = ({ children }) => {
  return <ul className={styles.HeaderItems}>{children}</ul>;
};

export default StageHeader;
